import React from "react";

import {
  Icon,
  Grid,
  Label,
  Segment,
  Header,
  Button,
  Input,
  Modal,
  Form,
  Card,
  Divider,
  Popup,
} from "semantic-ui-react";

import i18n from "../i18n";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import Menutest from "./menu.js";
/* import Modal from "react-modal"; */
import Carousel from "nuka-carousel";

import { reactLocalStorage } from "reactjs-localstorage";

import axios from "axios";
import "react-notifications-component/dist/theme.css";
import { BarChart } from "react-d3-components";
import DateTimePicker from "react-datetime-picker";
import { zIndex } from "material-ui/styles";
import { API_BASE_URL } from "../utils/endpoints";

const commaNumber = require("comma-number");
var containdata = false;
var img_prom = "";
var ip = API_BASE_URL;
var s2 = "localhost:3000";
var link;
const { detect } = require("detect-browser");
const browser = detect();
var dataDefault = [
  {
    label: "bulk_sms",
    values: [{ x: "bulk_sms", y: 0 }],
  },
];

var user_id = reactLocalStorage.get("user_id_login");
var data,
  data2 = [];
var data_admin = [];
var data_sub = [];
var data_admin_week = [];
var data_sub_admin_week = [];
var data_admin_month = [];
var data_sub_admin_month = [];
var balance_type = [];
var data_sub_admin_filter = [];
var data_admin_filter = [];
// handle the case where we don't detect the browser
if (browser) {
  if (ip.includes(s2)) {
    link =
      "http://192.168.100.20:81/public/dashboard/fec3ab5d-1035-4c74-90b7-d7e4d3006e24";
  } else if (browser.name == "edge" && !ip.includes(s2)) {
    link =
      API_BASE_URL.substring(
        0,
        window.location.origin.indexOf(":") + 3
      ) +
      window.location.hostname +
      ":81/public/dashboard/fec3ab5d-1035-4c74-90b7-d7e4d3006e24";
  } else {
    link =
      window.origin.substring(0, window.origin.indexOf(":") + 3) +
      window.location.hostname +
      ":8443/public/dashboard/fec3ab5d-1035-4c74-90b7-d7e4d3006e24";
  }
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const customStylesAdd = {
  content: {
    left: "0px",
    right: "auto",
    bottom: "auto",
    width: "100%",
  },
};

const description = {
  height: "auto",
  width: 700,
  marginLeft: "30%",
  marginTop: 200,
};

const descriptiona = {
  height: "auto",
  width: 700,
  marginLeft: "15%",
  marginTop: 200,
};
class Dashboardnew extends React.Component {
  constructor() {
    super();

    this.state = {
      user_id:'',
      modalIsOpenAdd: true,
      modalIsOpen: false,
      modalIsOpenlba: false,
      modalIsOpensurvey: false,
      modalIsOpeninter: false,
      modalIsOpenPromotion: false,
      modalIsOpenFilter: false,
      show: false,
      collapsed: false,
      collapseID: "",
      bulk_balance: "",
      bulk_expiry: "",
      bulk_balancePro: "",
      bulk_expirypro: "",
      profiled_balance: "",
      profiled_expiry: "",
      balance_general :'',
            balance_general_expiry: '',

      profiled_balancePro: "",
      profiled_expiryPro: "",
      lba_balance: "",
      lba_expiry: "",
      lba_balancePro: "",
      lba_expiryPro: "",
      survey_balance: "",
      survey_expiry: "",
      inter_balance: "",
      inter_expiry: "",
      inter_balancePro: "",
      inter_expiryPro: "",
      showOperator: false,
      image: [],
      UserID:'',
      imageAdd: [],
      data_sub_admin_week: [],
      data_sub_admin_month: [],
      data_admin_month: [],
      data_admin_filter: [],
      data_sub_admin_filter: [],
      isBulkPromotion: false,
      isLBAPromotion: false,
      isInternationalPromotion: false,
      isSurveyPromotion: false,
      viewMeta: false,
      isAdmin: false,
      isSubAdmin: false,
      viewchart: false,
      code: "",
      typeselect: "",
      date2: new Date(),
      date: new Date(),
      viewfilter: false,
      viewfilteradmin: false,
      viewchart1: false,
      viewchart2: false,
      viewchart3: false,
      viewchart4: false,
      viewchart5: false,
      viewchart6: false,
      viewchart7: false,
      ResetPasswordModal:false,
      img_prom: "",
      user_id_login: "",

      modalIsOpenFilter: false,
      modalOpenInternationalViewDetails: false,
      modalOpenLBAViewDetails: false,
      modalOpenSurveyViewDetails: false,
      modalOpenProfiledViewDetails: false,
    };

    this.openModalAdd = this.openModalAdd.bind(this);
    this.afterOpenModalAdd = this.afterOpenModalAdd.bind(this);
    this.closeModalAdd = this.closeModalAdd.bind(this);

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.openModallba = this.openModallba.bind(this);
    this.afterOpenModallba = this.afterOpenModallba.bind(this);
    this.closeModallba = this.closeModallba.bind(this);

    this.openModalsurvey = this.openModalsurvey.bind(this);
    this.afterOpenModalsurvey = this.afterOpenModalsurvey.bind(this);
    this.closeModalsurvey = this.closeModalsurvey.bind(this);

    this.openModalinter = this.openModalinter.bind(this);
    this.afterOpenModalinter = this.afterOpenModalinter.bind(this);
    this.closeModalinter = this.closeModalinter.bind(this);

    this.openModalPromotion = this.openModalPromotion.bind(this);
    this.afterOpenModalPromotion = this.afterOpenModalPromotion.bind(this);
    this.closeModalPromotion = this.closeModalPromotion.bind(this);

    this.openModalFilter = this.openModalFilter.bind(this);
    this.afterOpenModalFilter = this.afterOpenModalFilter.bind(this);
    this.closeModalFilter = this.closeModalFilter.bind(this);
  }
  openModalAdd() {
    this.setState({ modalIsOpenAdd: true });
  }

  handleOpenfilterFile = () => this.setState({ modalOpenfilterFile: true });
  handleClosefilterFile = () => this.setState({ modalOpenfilterFile: false });

  handleOpenResetPasswordModal = () => this.setState({ ResetPasswordModal: true });
 handleCloseResetPasswordModal = () => this.setState({ ResetPasswordModal: false });

  handleOpenLBAViewDetails = () =>
    this.setState({ modalOpenLBAViewDetails: true });
  handleCloseLBAViewDetails = () =>
    this.setState({ modalOpenLBAViewDetails: false });

  handleOpenProfiledViewDetails = () =>
    this.setState({ modalOpenProfiledViewDetails: true });
  handleCloseProfiledViewDetails = () =>
    this.setState({ modalOpenProfiledViewDetails: false });

  handleOpenSurveyViewDetails = () =>
    this.setState({ modalOpenSurveyViewDetails: true });
  handleCloseSurveyViewDetails = () =>
    this.setState({ modalOpenSurveyViewDetails: false });

  handleOpenInternationalViewDetails = () =>
    this.setState({ modalOpenInternationalViewDetails: true });
  handleCloseInternationalViewDetails = () =>
    this.setState({ modalOpenInternationalViewDetails: false });
  afterOpenModalAdd() {}

  closeModalAdd() {
    this.setState({ modalIsOpenAdd: false });
    // document.querySelector(".fixed_header").style = "z-index: 9 !important;";
    reactLocalStorage.set("fromLogin", 'false');
  }
  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {}

  closeModal() {
    this.setState({ modalIsOpen: false });
    /*     document.querySelector(".fixed_header").style = "z-index:9";
     */
  }

  openModalFilter() {
    this.setState({ modalIsOpenFilter: true });
  }

  afterOpenModalFilter() {}

  closeModalFilter() {
    this.setState({ modalIsOpenFilter: false });
    // document.querySelector(".fixed_header").style = "z-index:9";
  }

  openModallba() {
    this.setState({ modalIsOpenlba: true });
  }

  afterOpenModallba() {}

  closeModallba() {
    this.setState({ modalIsOpenlba: false });
    // document.querySelector(".fixed_header").style = "z-index:9";
  }
  openModalsurvey() {
    this.setState({ modalIsOpensurvey: true });
  }

  afterOpenModalsurvey() {}

  closeModalsurvey() {
    this.setState({ modalIsOpensurvey: false });
    // document.querySelector(".fixed_header").style = "z-index:9";
  }
  openModalinter() {
    this.setState({ modalIsOpeninter: true });
  }

  afterOpenModalinter() {}

  closeModalinter() {
    this.setState({ modalIsOpeninter: false });
    // document.querySelector(".fixed_header").style = "z-index:9";
  }
  openModalPromotion() {
    this.setState({ modalIsOpenPromotion: true });
  }

  afterOpenModalPromotion() {}

  closeModalPromotion() {
    this.setState({ modalIsOpenPromotion: false });
    // document.querySelector(".fixed_header").style = "z-index:9";
  }

  onChangetype = (values) => {
    this.setState({ typeselect: values.value });
  };

  formatDate = (date) =>{

//console.log(date.toISOString(),'ios')
////console.log(date.toLocaleString('sv'),'sv')
var a =date.toLocaleString('sv');
var b = a.replace(" ","T")
//console.log(b+'.000Z',"b")
return b+'.000Z'



  }

  load2 = () => {
    // to get dashboard data for admin (1 day)

   // console.log('loadd 2',  this.state.UserID);
    if (this.state.isAdmin) {
      // Check if UserID is available, if not get it from localStorage or skip the call
      var userId = this.state.UserID || reactLocalStorage.get("user_id_login") || '';
      
      // If UserID is still empty, skip the API call to avoid 404
      if (!userId) {
        console.log('UserID not available yet, skipping dashboard load');
        return;
      }
      
      var d = new Date();
   
     
      var d2 = new Date();
      var n = d.toISOString();
      var array = n.split('T');
      var arry2 =array[1].split(':')
      arry2[0]='T00'     
      var FromDate = array[0]+arry2[0]+":"+arry2[1]+":"+arry2[2];

    
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/" +
          userId +
          "/AdminDashboard?startDate=" +
          FromDate+
          "&endDate=" +
          this.formatDate(d2);
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/user/" +
          userId +
          "/AdminDashboard?startDate=" +
          FromDate +
          "&endDate=" +
          this.formatDate(d2);
      }
      var headers = { "Content-Type": "application/json", token: token };
      var array = [];
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
       
        const data_subadmin = res.data.result.sub_adimns;
       // data_admin=res.data.result.adimns
        var j, total_admin, service_type;
       
        console.log(Object.keys(res.data.result.admin).length)
        if (Object.keys(res.data.result.admin).length != 0) {
        
        if(res.data.result.admin.bulk_sms!= undefined){
          for (j = 0; j < res.data.result.admin.bulk_sms.length; j++) {
            total_admin = res.data.result.admin.bulk_sms[j].total_messages;
           
            service_type = res.data.result.admin.bulk_sms[j].service_type;
             data_admin.push({
              label: service_type,
               values: [{ x: service_type, y: parseInt(total_admin), y0: 0 }],
             });
             
            this.setState({ viewchart1: true });
          }
        }
        } else {
          data_admin.push({
            label: "",
            values: [{ x: "", y: 0, y0: 0 }],
          });
           this.setState({viewchart1:true})
        }

        const data_sub_admin = res.data.result.sub_adimns;

        var data_week_sub = Object.values(data_sub_admin);
        var j, total_admin, service_type;

        if (Object.keys(res.data.result.sub_adimns).length != 0) {
         if(res.data.result.sub_adimns.bulk_sms!=undefined){
          if (res.data.result.sub_adimns.bulk_sms.length > 0) {
            for (j = 0; j < res.data.result.sub_adimns.bulk_sms.length; j++) {
              total_admin =
                res.data.result.sub_adimns.bulk_sms[j].total_messages;
              service_type =
                res.data.result.sub_adimns.bulk_sms[j].service_type;
              data_sub.push({
                label: service_type,
                values: [{ x: service_type, y: parseInt(total_admin), y0: 0 }],
              });
              this.setState({ viewchart3: true });
            }
          } else {
            data_sub.push({
              label: "",
              values: [{ x: "", y: 0, y0: 0 }],
            });
            // this.setState({viewchart3:true})
          }
         }
        }
      }).catch((error) => {
        console.error('Error loading dashboard data:', error);
        // Handle 404 or other errors gracefully
        if (error.response && error.response.status === 404) {
          console.log('Dashboard data not available - UserID may not be set yet');
        }
      });

      // to get dashboard data for admin (1 week)

      var user_id = reactLocalStorage.get("user_id_login");
      var d = new Date();
      var n = d.toISOString();
      var ourDate = new Date();

      //Change it so that it is 7 days in the past.
      var pastDate = ourDate.getDate() - 7;
      ourDate.setDate(pastDate);

      var weekago = ourDate.toISOString();
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/" +
          user_id +
          "/AdminDashboard?startDate=" +
          weekago +
          "&endDate=" +
          this.formatDate(d);
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/user/" +
          user_id +
          "/AdminDashboard?startDate=" +
          weekago +
          "&endDate=" +
          this.formatDate(d);
      }
      var headers = { "Content-Type": "application/json", token: token };
      var array = [];
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        const data_admin = res.data.result.admin;
        var j, total_admin, service_type;
        if (Object.keys(res.data.result.admin).length != 0) {
       
          if (res.data.result.admin.bulk_sms != undefined) {
            for (j = 0; j < res.data.result.admin.bulk_sms.length; j++) {
              total_admin = res.data.result.admin.bulk_sms[j].total_messages;
              service_type = res.data.result.admin.bulk_sms[j].service_type;
             
              data_admin_week.push({
                label: service_type,
                values: [{ x: service_type, y: parseInt(total_admin), y0: 0 }],
              });
              this.setState({ viewchart4: true });
            }
          }
        } else {
          data_admin_week.push({
            label: "",
            values: [{ x: "", y: 0, y0: 0 }],
          });
          this.setState({ viewchart7: true });
        }
        const data_subadmin_week = res.data.result.sub_adimns;

        var data_week_sub = Object.values(data_subadmin_week);
        var i, k, l, total_subadmin, service_type_sub;

        for (i = 0; i < data_week_sub.length; i++) {
          if (data_week_sub[i].length > 0) {
            for (k = 0; k < data_week_sub[i].length; k++) {
              total_subadmin = data_week_sub[i][k].total_messages;
              service_type_sub = data_week_sub[i][k].service_type;
              data_sub_admin_week.push({
                label: service_type_sub,
                values: [
                  { x: service_type_sub, y: parseInt(total_subadmin), y0: 0 },
                ],
              });
            }
            this.setState({ viewchart2: true });
          } else {
            data_sub_admin_week.push({
              label: "",
              values: [{ x: "", y: 0, y0: 0 }],
            });
            
            //   this.setState({viewchart2:true})
          }
        }

        this.setState({ data_sub_admin_week });
      });

      // to get dashboard data for admin (1 month)
      var ourDate = new Date();
      var pastDate = ourDate.getDate() - 30;
      ourDate.setDate(pastDate);

      var weekago = ourDate.toISOString();
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/" +
          user_id +
          "/AdminDashboard?startDate=" +
          weekago +
          "&endDate=" +
          this.formatDate(d);
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/user/" +
          user_id +
          "/AdminDashboard?startDate=" +
          weekago +
          "&endDate=" +
          this.formatDate(d);
      }
      var headers = { "Content-Type": "application/json", token: token };
      var array = [];
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        const data_admin = res.data.result.admin;

        var j, total_admin, service_type;
        if (Object.keys(res.data.result.admin).length != 0) {
          if(res.data.result.admin.bulk_sms!= undefined){
            for (j = 0; j < res.data.result.admin.bulk_sms.length; j++) {
              total_admin = res.data.result.admin.bulk_sms[j].total_messages;
              service_type = res.data.result.admin.bulk_sms[j].service_type;
              data_admin_month.push({
                label: service_type,
                values: [{ x: service_type, y: parseInt(total_admin), y0: 0 }],
              });
              this.setState({ viewchart5: true });
          }
        }
        } else {
          data_admin_month.push({
            label: "",
            values: [{ x: "", y: 0, y0: 0 }],
          });
           this.setState({viewchart5:true})
        }
        const data_subadmin_week = res.data.result.sub_adimns;

        var data_week_sub = Object.values(data_subadmin_week);
        var i, k, l, total_subadmin, service_type_sub;
        for (i = 0; i < data_week_sub.length; i++) {
          for (k = 0; k < data_week_sub[i].length; k++) {
            total_subadmin = data_week_sub[i][k].total_messages;
            service_type_sub = data_week_sub[i][k].service_type;
            data_sub_admin_month.push({
              label: service_type_sub,
              values: [
                { x: service_type_sub, y: parseInt(total_subadmin), y0: 0 },
              ],
            });
            this.setState({ viewchart6: true });
          }
        }
      
        
        this.setState({ viewchart: true, data_sub_admin_month });
      });
    }
  };

  componentDidMount() {

    var x = this;
    //  reactLocalStorage.set('loginDashboard',true)
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ viewMeta: true });
    }
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      this.setState({ isAdmin: true });
    }
    if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
      this.setState({ isSubAdmin: true });
    }
    if (reactLocalStorage.get("fromLogin") == "true") {
      // document.querySelector(".fixed_header").style = "z-index: -1 !important;";
    } else {
      // document.querySelector(".fixed_header").style = "z-index: 9 !important;";
    }
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".mof_color").style =
        "direction: rtl;float: right;";
      // document.querySelector(".details_2").style =
      // "margin-right: -2% !important;margin-left: 2% !important;";
      //document.querySelector(".details_3").style =
      //"margin-left: 2% !important;";
      //document.querySelector(".details_4").style =
      //"margin-left: 2% !important;";
      document.querySelector(".fixed_div").style =
        "margin-right: 0% !important;";
    } else {
      this.setState({ isArabic: false });
    }

    var token = reactLocalStorage.get("accessToken");
    if (token === undefined) {
      window.location = "app";
    }
    var id=''

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      reactLocalStorage.set("user_id_login", res.data.result.id);
      this.setState({
        UserID:res.data.result.id
      })
    
      this.setState({user_id:res.data.result.id})
      id=res.data.result.id
      
      reactLocalStorage.set("user_name_login", res.data.result.id);
      this.setState({ user_id_login: res.data.result.id });
      reactLocalStorage.set("email_login", res.data.result.userName);
      reactLocalStorage.set("migrated", res.data.result.migrated);
      reactLocalStorage.set("customerID", res.data.result.customerID);
      reactLocalStorage.set("packageID", res.data.result.packageID);
      if(res.data.result.default_password==1){
        this.setState({
          ResetPasswordModal:true
        })
      }else{
        this.setState({
          ResetPasswordModal:false
        })
      }





      var token = reactLocalStorage.get("accessToken");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/balance/getBalance/" +
          res.data.result.id
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/balance/getBalance/" +
          res.data.result.id
      }
  
      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.ErrorDescription === "user is not authenticated") {
          window.location = "/app/";
        } else {
          const data = res.data.result.balances;
          reactLocalStorage.set("lba", 'false');
          reactLocalStorage.set("bulk", 'false');
          reactLocalStorage.set("profiled", 'false');
          reactLocalStorage.set("international", 'false');
          var i;
          if (data) {
            var used;
            var reserved;
            var balance;
            var newbalance;
            var promo;
            if (data.bulk_sms) {
              reactLocalStorage.set("bulk", 'true');
            
              used = data.bulk_sms.used;
              reserved = data.bulk_sms.reserved;
              balance = data.bulk_sms.balance;
              var bulkpromo = data.bulk_sms_promotion;
              if (bulkpromo) {
                this.setState({ isBulkPromotion: false });
              }
  
              if (used != undefined && reserved != undefined) {
                newbalance = balance - used - reserved;
              } else if (used === undefined && reserved === undefined) {
                newbalance = data.bulk_sms.balance;
              } else if (reserved != undefined) {
                newbalance = data.bulk_sms.balance - data.bulk_sms.reserved;
              } else if (used != undefined) {
                newbalance = data.bulk_sms.balance - data.bulk_sms.used;
              }
              this.setState({ bulk_balance: newbalance });
              this.setState({ bulk_expiry: data.bulk_sms.expiry });
            }
            if (data.bulk_sms_promotion) {
              this.setState({ isBulkPromotion: true });
              reactLocalStorage.set("bulk", 'true');
              this.setState({
                bulk_balancePro: data.bulk_sms_promotion.balance,
              });
              this.setState({ bulk_expiryPro: data.bulk_sms_promotion.expiry });
            }
            if (data.profiled_sms) {
              reactLocalStorage.set("profiled", 'true');
              used = data.profiled_sms.used;
              reserved = data.profiled_sms.reserved;
              balance = data.profiled_sms.balance;
              newbalance = balance - used - reserved;
              var profiledpromo = data.profiled_sms_promotion;
              if (profiledpromo) {
                this.setState({ isProfiledPromotion: false });
              }
              if (used != undefined && reserved != undefined) {
                newbalance = balance - used - reserved;
              } else if (used === undefined && reserved === undefined) {
                newbalance = data.profiled_sms.balance;
              } else if (reserved != undefined) {
                newbalance =
                  data.profiled_sms.balance - data.profiled_sms.reserved;
              } else if (used != undefined) {
                newbalance = data.profiled_sms.balance - data.profiled_sms.used;
              }
              this.setState({ profiled_balance: newbalance });
              this.setState({ profiled_expiry: data.profiled_sms.expiry });
            }
            if (data.profiled_sms_promotion) {
              reactLocalStorage.set("profiled", 'true');
              this.setState({
                profiled_balancePro: data.profiled_sms_promotion.balance,
              });
              this.setState({
                profiled_expiryPro: data.profiled_sms_promotion.expiry,
              });
              this.setState({ isProfiledPromotion: true });
            }
  
         if(data.balance_general){
              const generalExpiry = data[""] && data[""].expiry ? data[""].expiry : "";
              this.setState({
                balance_general: data.balance_general,
                balance_general_expiry: generalExpiry
              })
            }
  
            if (data.lba_sms) {
              reactLocalStorage.set("lba", 'true');
             
              used = data.lba_sms.used;
              reserved = data.lba_sms.reserved;
              balance = data.lba_sms.balance;
              newbalance = balance - used - reserved;
              var lbapromo = data.lba_sms_promotion;
              if (lbapromo) {
                this.setState({ isLBAPromotion: false });
              }
              if (used != undefined && reserved != undefined) {
                newbalance = balance - used - reserved;
              } else if (used === undefined && reserved === undefined) {
                newbalance = data.lba_sms.balance;
              } else if (reserved != undefined) {
                newbalance = data.lba_sms.balance - data.lba_sms.reserved;
              } else if (used != undefined) {
                newbalance = data.lba_sms.balance - data.lba_sms.used;
              }
              this.setState({ lba_balance: newbalance });
              this.setState({ lba_expiry: data.lba_sms.expiry });
            }
            if (data.lba_sms_promotion) {
              reactLocalStorage.set("lba", 'true');
              this.setState({ lba_balancePro: data.lba_sms_promotion.balance });
              this.setState({ lba_expiryPro: data.lba_sms_promotion.expiry });
              this.setState({ isLBAPromotion: true });
            }
  
            if (data.survey) {
              used = data.survey.used;
              reserved = data.survey.reserved;
              balance = data.survey.balance;
              newbalance = balance - used - reserved;
              /* promo=data.survey.data.survey+'_'+promotion;
                        if(promo){
                          this.setState({isPromotion:true})
                        }*/
              if (used === undefined && reserved === undefined) {
                newbalance = data.survey.balance;
              }
              if (reserved != undefined) {
                newbalance = data.survey.balance - data.survey.reserved;
              }
              if (used != undefined) {
                newbalance = data.survey.balance - data.survey.used;
              }
              this.setState({ survey_balance: newbalance });
              this.setState({ survey_expiry: data.survey.expiry });
            }
            if (data.international_sms) {
              reactLocalStorage.set("international", 'true');
              used = data.international_sms.used;
              reserved = data.international_sms.reserved;
              balance = data.international_sms.balance;
              newbalance = balance - used - reserved;
              var interpromo = data.international_sms_promotion;
              if (interpromo) {
                this.setState({ isInternationalPromotion: false });
              }
              if (used != undefined && reserved != undefined) {
                newbalance = balance - used - reserved;
              } else if (used === undefined && reserved === undefined) {
                newbalance = data.international_sms.balance;
              } else if (reserved != undefined) {
                newbalance =
                  data.international_sms.balance -
                  data.international_sms.reserved;
              } else if (used != undefined) {
                newbalance =
                  data.international_sms.balance - data.international_sms.used;
              }
              this.setState({ inter_balance: newbalance });
              this.setState({ inter_expiry: data.international_sms.expiry });
              
            }
            if (data.international_sms_promotion) {
              reactLocalStorage.set("international", 'true');
              this.setState({ isInternationalPromotion: true });
              this.setState({
                inter_balancePro: data.international_sms_promotion.balance,
              });
              this.setState({
                inter_expiryPro: data.international_sms_promotion.expiry,
              });
            }
          }
        }
      });
  

    
      this.load2();
    });



   
  }
  onChangedatetime = (date) => {
    this.setState({ date });
  };
  onChangedatetime2 = (date2) => {
    this.setState({ date2: date2 });
  };

  componentWillMount() {
   
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ showOperator: true });
    }

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.advertisments;
      if (persons != undefined) {
        var array = [];
        var i;
        var value;
        for (i = 0; i < persons.length; i++) {
          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var link;
          if (ip.includes(s2)) {
            value = persons[i].advertisment__src;
            array.push({ url: "http://" + value });
          } else {
            value = persons[i].advertisment__src.replace(
              "192.168.100.9",
              API_BASE_URL
            );
            array.push({ url: value });
          }
        }
       
        this.setState({ imageAdd: array });
       
        if (res.data.result.advertisments.length > 0) {
          containdata = true;
        }
     
        if (
          reactLocalStorage.get("fromLogin") == 'true' &&
          containdata == true
        ) {

          this.setState({ modalIsOpenAdd: true });
          //  document.querySelector(".fixed_header").style = "z-index: -1 !important;";
        } else {
          this.setState({ modalIsOpenAdd: false });
          //  document.querySelector(".fixed_header").style = "z-index: 9 !important;";
        }
      }
    });
  }
  viewPromotion = (event) => {
    var name = event.target.name;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/advertisments/getAdv/" +
        name;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/advertisments/getAdv/" + name;
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.advertisments;
      if (persons != undefined) {
        var array = [];
        var i;
        var value;
        value = persons.advertisment__src;

        img_prom = value;
        img_prom = "http://" + value.replace("/", ":8080/");
        if (ip.includes(s2)) {
          var new_img = img_prom.replace(
            "192.168.100.9:8080",
            "77.245.11.201:8081"
          );
          this.setState({ img_prom: new_img });
        } else {
          this.setState({ img_prom: img_prom });
        }
      }
    });
    this.setState({ modalIsOpenPromotion: true });
  };
  viewDetails = (event) => {
    var type = event.target.name;
    if (type == "profile") {
      this.setState({ modalIsOpen: true });
      /* document.querySelector(".fixed_header").style = "z-index:-1"; */
    }
    if (type == "lba") {
      this.setState({ modalIsOpenlba: true });
      // document.querySelector(".fixed_header").style = "z-index:-1";
    }
    if (type == "survey") {
      this.setState({ modalIsOpensurvey: true });
      /* document.querySelector(".fixed_header").style = "z-index:-1"; */
    }
    if (type == "internationl") {
      this.setState({ modalIsOpeninter: true });
      /*  document.querySelector(".fixed_header").style = "z-index:-1"; */
    }
  };
  goTocontactus = (event) => {
    var type = event.target.name;
    reactLocalStorage.set("user_type", type);
    window.location = "/app/ContactUSType";
  };
  openFilter = () => {
    this.setState({ modalIsOpenFilter: true });
  };
  onChangeStartdate = (date) => {
    this.setState({ Startdate: data });
  };
 
  onChangeEnddate = (date) => {
    this.setState({ Enddate: data });
  };
  OpenChart = (event) => {
  //  var startDate = this.state.date.toString();
   // var endDate = this.state.date2.toString();
      var startDate = new Date(this.state.date)
    var endDate =new Date(this.state.date2)
   
    var user_id = this.state.UserID || reactLocalStorage.get("user_id_login") || '';
    if (!user_id) {
      console.log('UserID not available, cannot load chart');
      return;
    }

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        user_id +
        "/AdminDashboard?startDate=" +
        this.formatDate(startDate)+
        "&endDate=" +
        this.formatDate(endDate);
    } else {
      apiBaseUrl =
        window.location.origin +
        "/core/user/rest/user/" +
        user_id +
        "/AdminDashboard?startDate=" +
        this.formatDate(startDate)+
        "&endDate=" +
        this.formatDate(endDate);
    }
    var headers = { "Content-Type": "application/json", token: token };
    var array = [];
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data_admin = res.data.result.admin;

      var j, total_admin, service_type;
      if(Object.keys(res.data.result.admin).length != 0){

      for (j = 0; j < res.data.result.admin.bulk_sms.length; j++) {
        
        total_admin = res.data.result.admin.bulk_sms[j].total_messages;
        service_type = res.data.result.admin.bulk_sms[j].service_type;
        data_admin_filter.push({
          label: service_type,
          values: [{ x: service_type, y: parseInt(total_admin), y0: 0 }],
        });
        this.setState({ viewfilteradmin: true });
      }}

      const data_subadmin_week = res.data.result.sub_adimns;

      var data_week_sub = Object.values(data_subadmin_week);
      var i, k, l, total_subadmin, service_type_sub;
      for (i = 0; i < data_week_sub.length; i++) {
        for (k = 0; k < data_week_sub[i].length; k++) {
          total_subadmin = data_week_sub[i][k].total_messages;
          service_type_sub = data_week_sub[i][k].service_type;
          data_sub_admin_filter.push({
            label: service_type_sub,
            values: [
              { x: service_type_sub, y: parseInt(total_subadmin), y0: 0 },
            ],
          });
          this.setState({ viewfilter: true });
        }
      }
      this.setState({ data_sub_admin_filter });
      this.setState({ modalOpenfilterFile: false });
    });
  };

  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_request">
            <div className="main_request">
              <Grid columns={2} divided className="fixed_div">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style mof_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                
                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="dashboard" />
                    {i18n.t("Dashboard.label")}
                  </Header>
                </Divider>
             
                  <>
                {this.state.isAdmin ? 

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenfilterFile}
                  >
                    {i18n.t("filter.label")}
                    <Icon name="sort amount up" color="black" />
                 
                 </Button> :''}  
              { reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_ADMIN" ?
              reactLocalStorage.get('packageID')==='1692' ? null : <Button.Group>
    
               <Button  color="teal" basic  >

               <Icon name="bell" />
               {this.state.isArabic
                                   ? "الرصيد العام"
                                   : "General Balance"}
               </Button>
              


              {this.state.isArabic ?
               <Button  color="teal" >
               {commaNumber(this.state.balance_general/1000).replace(',','.') != null ? commaNumber(this.state.balance_general/1000).replace(',','.')+ ' د.أ ' : "-"}
               </Button> :
                <Button  color="teal" >
                {commaNumber(this.state.balance_general/1000).replace(',','.') != null ? commaNumber(this.state.balance_general/1000).replace(',','.') + ' JOD' : "-"}
                </Button>}
                  {this.state.balance_general_expiry && this.state.balance_general_expiry !== "" ?
                <Button color="teal" basic>
                  {this.state.isArabic ? "تاريخ الانتهاء" : "Expiry"}: {this.state.balance_general_expiry}
                </Button>
                : null}
             </Button.Group>
             :null  
            }

                  </>
                

               
                {this.state.isAdmin || this.state.isSubAdmin ? (
                 reactLocalStorage.get("packageID")=='1692' ?
                 <Card.Group className="cust_grid">
                  <br />
                <br />
                 { this.state.isBulkPromotion &&
                  <Card color="black">
                    <Card.Content header="Bulk SMS" />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <> <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.bulk_balance).replace(',','.')}
                      <br />
                      <Icon name="calendar alternate outline" />
                      
                      {i18n.t("Expiry_Date.label")} : {this.state.bulk_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="Bulk SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.bulk_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.bulk_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isBulkPromotion ? false : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card> }

                  { this.state.isProfiledPromotion &&
                  <Card color="black">
                    <Card.Content header={i18n.t("Profiled_SMS.label")} />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <> <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                       <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.profiled_balance)}
                      <br />
                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :
                      {this.state.profiled_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="Profiled SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.profiled_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.profiled_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isProfiledPromotion ? true : false
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")} 
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                   }

                  { this.state.isLBAPromotion &&  
                  <Card color="black">
                    <Card.Content header={i18n.t("LBA_SMS.label")} />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >

                     <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.lba_balance)}
                      <br />

                    
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} : {this.state.lba_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="LBA SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.lba_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.lba_expiry}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isLBAPromotion ? false : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                  }
{/* 
                  { this.state.isInternationalPromotion && 
                  <Card color="black">
                    <Card.Content
                      header={i18n.t("International_SMS.label")}
                    /> 
                    {reactLocalStorage.get("packageID")=='1693' ?
                    <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.inter_balance)}
                      <br />

                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :{" "}
                      {this.state.inter_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="International SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.inter_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.inter_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isInternationalPromotion
                                  ? false
                                  : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                  } */}

                { this.state.isSurveyPromotion && 
                  <Card color="black">
                    <Card.Content header={i18n.t("Survey_SMS.label")} />
                    
                   
                    {reactLocalStorage.get("packageID")=='1693' ?
                    <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.survey_balance)}
                      <br />

                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :{" "}
                      {this.state.survey_expiry}
                    </Card.Content></>:null }
                   
                  
                  
                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Button
                          basic
                          color="teal"
                          name="filter"
                          onClick={this.handleOpenSurveyViewDetails}
                        >
                          {" "}
                          {i18n.t("viewDetails.label")}
                        </Button>

                        <Button
                          basic
                          color="teal"
                          onClick={this.goTocontactus}
                        >
                          {i18n.t("contact_us.label")}
                        </Button>
                      </div>
                    </Card.Content>
                  </Card>

                }
                <br></br><br></br>

                </Card.Group>
                 :

                 <Card.Group className="cust_grid">
               
                  <Card color="black">
                    <Card.Content header="Bulk SMS" />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <> <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.bulk_balance).replace(',','.')}
                      <br />
                      <Icon name="calendar alternate outline" />
                      
                      {i18n.t("Expiry_Date.label")} : {this.state.bulk_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="Bulk SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.bulk_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.bulk_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isBulkPromotion ? false : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card> 

                  <Card color="black">
                    <Card.Content header={i18n.t("Profiled_SMS.label")} />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <> <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                       <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.profiled_balance)}
                      <br />
                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :
                      {this.state.profiled_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="Profiled SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.profiled_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.profiled_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isProfiledPromotion ? false : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                   

                 
                  <Card color="black">
                    <Card.Content header={i18n.t("LBA_SMS.label")} />
                    {reactLocalStorage.get("packageID")=='1693' ?
                     <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >

                     <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.lba_balance)}
                      <br />

                    
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} : {this.state.lba_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="LBA SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.lba_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.lba_expiry}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isLBAPromotion ? false : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                  

                 
                  <Card color="black">
                    <Card.Content
                      header={i18n.t("International_SMS.label")}
                    /> 
                    {reactLocalStorage.get("packageID")=='1693' ?
                    <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.inter_balance)}
                      <br />

                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :{" "}
                      {this.state.inter_expiry}
                    </Card.Content></>:null }

                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Popup
                          on="click"
                          header="International SMS Promotion"
                          content={
                            <Card.Content
                              style={{ color: "grey", width: "230px" }}
                              extra
                              textAlign={
                                this.state.isArabic ? "right" : "left"
                              }
                            >
                              <Icon name="dollar sign" />{" "}
                              {i18n.t("Remaining_Balance.label")}{" "}
                              {this.state.inter_balancePro}
                              <br />
                              <br />
                              <Icon name="calendar alternate outline" />{" "}
                              {i18n.t("Expiry_Date.label")} :{" "}
                              {this.state.inter_expiryPro}
                            </Card.Content>
                          }
                          trigger={
                            <Button
                              disabled={
                                this.state.isInternationalPromotion
                                  ? false
                                  : true
                              }
                              color="teal"
                            >
                              {i18n.t("view_promotion.label")}
                            </Button>
                          }
                        />
                      </div>
                    </Card.Content>
                  </Card>
                

              
                  <Card color="black">
                    <Card.Content header={i18n.t("Survey_SMS.label")} />
                    
                   
                    {reactLocalStorage.get("packageID")=='1693' ?
                    <>
                    <Card.Content
                      extra
                      textAlign={this.state.isArabic ? "right" : "left"}
                    >
                      <Icon name="dollar sign" />{" "}
                      {i18n.t("Remaining_Balance.label")}{" "}
                      {commaNumber(this.state.survey_balance)}
                      <br />

                      
                      <Icon name="calendar alternate outline" />
                      {i18n.t("Expiry_Date.label")} :{" "}
                      {this.state.survey_expiry}
                    </Card.Content></>:null }
                   
                  
                  
                    <Card.Content extra>
                      <div className="ui two buttons">
                        <Button
                          basic
                          color="teal"
                          name="filter"
                          onClick={this.handleOpenSurveyViewDetails}
                        >
                          {" "}
                          {i18n.t("viewDetails.label")}
                        </Button>

                        <Button
                          basic
                          color="teal"
                          onClick={this.goTocontactus}
                        >
                          {i18n.t("contact_us.label")}
                        </Button>
                      </div>
                    </Card.Content>
                  </Card>

               
                </Card.Group>

                
                ) : (
                  ""
                )}

                {this.state.showOperator ? (
                  this.state.viewMeta ? (
                    <iframe
                      src={link}
                      frameborder="0"
                      width="800"
                      height="600"
                      allowtransparency
                      className="iframedata"
                      title="iframedashboard"
                      style={{
                        marginTop: this.state.showOperator
                          ? "0% "
                          : "12% !important",
                      }}
                    />
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

            

                {this.state.isAdmin ? (
                  <div
                    className="admin_data"
                    style={{ marginRight: this.state.isArabic ? "2%" : "" }}
                  >
                   
                    {this.state.viewchart1 === true ||

                    this.state.viewchart4 === true ||
                    this.state.viewchart5 === true ? (
                      <h5
                        className="text_style "
                        style={{
                          color: "black",
                          float: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {i18n.t("basic_information.label")}
                      </h5>
                    ) : (
                      ""
                    )}
                    <div className="chart_admin">
                      {this.state.viewchart1 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_day.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_day.label")}
                        </h6>
                      )}

                      {this.state.viewchart1 === true ? (
                        <>
                      
                        <BarChart
                        data={data_admin}
                        width={300}
                        height={400}
                        margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                      /></>
                        
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                      {this.state.viewchart4 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_week.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_week.label")}
                        </h6>
                      )}
                      {this.state.viewchart4 === true ? (
                        <BarChart
                          data={data_admin_week}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                      {this.state.viewchart5 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_month.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("admin_chart_per_month.label")}
                        </h6>
                      )}
                      {this.state.viewchart5 === true ? (
                        <BarChart
                          data={data_admin_month}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                    </div>

                    {this.state.viewchart3 === true ||
                    this.state.viewchart2 === true ||
                    this.state.viewchart6 === true ? (
                      <h5
                        className="text_style"
                        style={{
                          color: "black",
                          float: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {i18n.t("basic_information_sub.label")}
                      </h5>
                    ) : (
                      <h5
                        className="text_style"
                        style={{
                          color: "black",
                          float: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {i18n.t("basic_information_sub.label")}
                      </h5>
                    )}
                    <div className="chart_admin">
                      {this.state.viewchart3 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_day.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_day.label")}
                        </h6>
                      )}
                      {this.state.viewchart3 === true ? (
                        <BarChart
                          data={this.state.data_sub}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                      {this.state.viewchart2 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_week.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_week.label")}
                        </h6>
                      )}
                      {this.state.viewchart2 === true ? (
                        <BarChart
                          data={data_sub_admin_week}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                      {this.state.viewchart6 === true ? (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_month.label")}
                        </h6>
                      ) : (
                        <h6 className="text_style " style={{ color: "black" }}>
                          {i18n.t("subadmin_chart_per_month.label")}
                        </h6>
                      )}
                      {this.state.viewchart6 === true ? (
                        <BarChart
                          data={data_sub_admin_month}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      ) : (
                        <BarChart
                          data={dataDefault}
                          width={300}
                          height={400}
                          margin={{ top: 10, bottom: 50, left: 50, right: 10 }}
                        />
                      )}
                    </div>

                    {this.state.viewfilteradmin === true ||
                    this.state.viewfilter === true ? (
                      <div className="filterDiv">
                        <h5 className="text_style" style={{ color: "black" }}>
                          {i18n.t("data_filtering.label")}
                        </h5>
                        <div className="chart_admin">
                          {this.state.viewfilteradmin === true ? (
                            <p>{i18n.t("admin_chart.label")}</p>
                          ) : (
                            ""
                          )}
                          <br />
                          {this.state.viewfilteradmin === true ? (
                            <BarChart
                              data={data_admin_filter}
                              width={300}
                              height={400}
                              margin={{
                                top: 10,
                                bottom: 50,
                                left: 50,
                                right: 10,
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {this.state.viewfilter === true ? (
                            <p>{i18n.t("sub_admin_chart.label")}</p>
                          ) : (
                            ""
                          )}
                          {this.state.viewfilter === true ? (
                            <BarChart
                              data={data_sub_admin_filter}
                              width={300}
                              height={400}
                              margin={{
                                top: 10,
                                bottom: 50,
                                left: 50,
                                right: 10,
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </Segment>
            </div>
          </div>
        </div>

        <Modal
          Open={this.state.modalIsOpenPromotion}
          basic
          size="fullscreen"
          onClose={this.closeModalPromotion}
         
        >
          <Modal.Content>
            <h2 ref={(subtitle) => (this.subtitle = subtitle)} />
            
            <br />
            <div className="slider_auth">
              <img src={this.state.img_prom} className="slider_pic" />
            </div>
            <br />
            <br />
            <div className="cust_grid">
              <Button onClick={this.closeModalAdd}>
                {i18n.t("Close.label")}
              </Button>
            </div>
          </Modal.Content>
        </Modal>

        <Modal
         
          open={this.state.modalIsOpenAdd}
          basic
          size="fullscreen"
          onClose={this.closeModalAdd}
        >
          <Modal.Content>
           
            <h2 ref={(subtitle) => (this.subtitle = subtitle)} />
            <br />
            <div className="slider_auth">
              <div style={{ paddingLeft: "50px " }}>
               
                <Carousel>
                  
                  {this.state.imageAdd.map((img) => (
                    <img src={img.url} className="slider_pic" />
                   
                  
                    
                  ))}
                </Carousel>
              </div>
              <br />
              <br />
              <div className="cust_grid">
                <Button onClick={this.closeModalAdd}>
                  {i18n.t("Close.label")}
                </Button>
              </div>
            </div>
          </Modal.Content>
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          size="small"
          open={this.state.modalOpenfilterFile}
          className="add"
          onClose={this.handleClosefilterFile}
          style={this.state.isArabic ? descriptiona : description}
        >
          <Header content={i18n.t("filter_details.label")} />
          <Modal.Content style={{ height: "220px" }} scrolling>
            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
            >
              {i18n.t("start_date.label")}
            </label>

            <DateTimePicker
              onChange={this.onChangedatetime}
              value={this.state.date}
              style={{ zIndex: "9" }}
            />
            <br />

            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
            >
              {i18n.t("end_date.label")}
            </label>
            <DateTimePicker
              onChange={this.onChangedatetime2}
              value={this.state.date2}
              style={{ zIndex: "9" }}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("view_chart.label")}
              onClick={this.OpenChart}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleClosefilterFile}
            />
          </Modal.Actions>
        </Modal>


        <Modal
          //closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          className="add"
          size="small"
          open={this.state.ResetPasswordModal}
          onClose={this.handleCloseResetPasswordModal}
          style={this.state.isArabic ? descriptiona : description}
        >
         
          {this.state.isArabic ? (
            <Modal.Content><p style={{ fontSize: "16px",color:'red' }}>الرجاء تغيير كلمة السر قبل الخروج من النظام</p></Modal.Content>
          ) : (
            <Modal.Content>
              <p style={{ fontSize: "16px",color:'red' }}>
                Please Change your password before exit from the system
              </p>
            </Modal.Content>
          )}

           <Modal.Actions>
            <Button
              color="black"
              content={i18n.t("OK.label")}
              onClick={this.handleCloseResetPasswordModal}
            />
          </Modal.Actions> 
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          className="add"
          size="small"
          open={this.state.modalOpenProfiledViewDetails}
          onClose={this.handleCloseProfiledViewDetails}
          style={this.state.isArabic ? descriptiona : description}
        >
          <Header
            icon="mail outline"
            content={i18n.t("profile_details.label")}
          />
          {this.state.isArabic ? (
            <Modal.Content> {i18n.t("profile_desc.label")}</Modal.Content>
          ) : (
            <Modal.Content>
              <p style={{ fontSize: "14px" }}>
                {" "}
                A Mobile Advertising platform which enables customers to send
                targeted SMS campaigns based on the{" "}
              </p>
              <p>
                {" "}
                profile they select. Profiled SMS is aimed towards customers who
                want to purchase targeted advertising{" "}
              </p>
              <p>
                {" "}
                where the customer will be selecting the profile of targeted
                users to receive the campaign materials
              </p>
              <p>
                [work location, home location, age, gender and nationality] .
              </p>
            </Modal.Content>
          )}

          <Modal.Actions>
            <Button
              color="black"
              content={i18n.t("Close.label")}
              onClick={this.handleCloseProfiledViewDetails}
            />
          </Modal.Actions>
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          className="add"
          size="small"
          open={this.state.modalOpenLBAViewDetails}
          onClose={this.handleCloseLBAViewDetails}
          style={this.state.isArabic ? descriptiona : description}
        >
          <Header icon="mail outline" content={i18n.t("lba_details.label")} />
          {this.state.isArabic ? (
            <Modal.Content textAlign="right">
              {" "}
              {i18n.t("lba_desc.label")}
            </Modal.Content>
          ) : (
            <Modal.Content>
              <p style={{ fontSize: "14px" }}>
                To reduce costs and increase relevance, you can target your
                innovative SMS advertisements based on{" "}
              </p>
              <p>location and other demographic variables. </p>
            </Modal.Content>
          )}

          <Modal.Actions>
            <Button
              color="black"
              content={i18n.t("Close.label")}
              onClick={this.handleCloseLBAViewDetails}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="add"
          closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          size="small"
          open={this.state.modalOpenSurveyViewDetails}
          onClose={this.handleCloseSurveyViewDetails}
          style={this.state.isArabic ? descriptiona : description}
        >
          <Header
            icon="mail outline"
            content={i18n.t("survey_details.label")}
          />
          {this.state.isArabic ? (
            <Modal.Content>{i18n.t("survey_desc.label")}</Modal.Content>
          ) : (
            <Modal.Content />
          )}
          <Modal.Content>
            <p style={{ fontSize: "14px" }}>
              {" "}
              In order to gather customer sentiments, we have created a simple
              and efficient tool that targets{" "}
            </p>
            <p>
              {" "}
              recipients according to their location, gender, age, etc. This
              way, research and market analysis can be{" "}
            </p>
            <p>
              conducted seamlessly. The survey would be shared by sending a link
              to their device and a reward would
            </p>
            <p> be granted upon completion.</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="black"
              content={i18n.t("Close.label")}
              onClick={this.handleCloseSurveyViewDetails}
            />
          </Modal.Actions>
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          className="add"
          size="small"
          open={this.state.modalOpenInternationalViewDetails}
          onClose={this.handleCloseInternationalViewDetails}
          style={this.state.isArabic ? descriptiona : description}
        >
          <Header
            icon="mail outline"
            content={i18n.t("international_details.label")}
          />
          {this.state.isArabic ? (
            <Modal.Content>{i18n.t("inter_desc.label")}</Modal.Content>
          ) : (
            <Modal.Content>
              <p style={{ fontSize: "14px" }}>
                {" "}
                Offers corporate customers the opportunity to send international
                promotional messages on their clients’{" "}
              </p>
              <p> handsets.</p>
            </Modal.Content>
          )}
          <Modal.Actions>
            <Button
              color="black"
              content="Close"
              onClick={this.handleCloseInternationalViewDetails}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Dashboardnew);
